import React, { useState, useEffect } from 'react';
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import BaseOptionChart from './BaseOptionChart';
import { fCurrency } from 'src/utils/formatNumber';
import { Divider, Typography, CircularProgress, Alert } from '@material-ui/core';
import StickyNoteJobCost from '../_dashboard/crm/tickets/StickyNoteJobCost';
import JobCostJobNotesMessageBoard from '../_dashboard/user/profile/JobCostJobNotesMessageBoard';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';

export default function JobCostNotesPage({ logs, setLogs, fetchJobCostLogs, projectData, requestId }) {
  const [jobNoteMembers, setJobNoteMembers] = useState(null);
  const [requestDetails, setRequestDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [renderCards, setRenderCards] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [customerOrderData, setCustomerOrderData] = useState(null);

  const fetchRequestDetails = async (requestId) => {
    if (!requestId) return;

    setLoading(true);
    setError(null);
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user || !user.user_id || !user.user_type) {
        throw new Error('User information not found');
      }

      const res = await axios.post(`${REST_API_END_POINT}request/get-job-cost-notes-details`, {
        request_id: requestId,
        userId: user.user_id,
        userType: user.user_type,
      });

      if (res?.data?.status === 1) {
        setJobNoteMembers(res?.data?.jobNoteMembers || []);
        setRequestDetails(res?.data?.data?.[0] || null);
      } else {
        throw new Error('Failed to fetch request details');
      }
    } catch (error) {
      console.error('Error fetching request details:', error);
      setError(error.message || 'Failed to fetch request details');
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomerOrderDetails = async (orderId) => {
    if (!orderId) return;

    try {
      const res = await axios.post(
        `${REST_API_END_POINT}get-customer-order-product/${orderId}`
      );
      if (res?.data?.status === 1) {
        setCustomerOrderData(res.data.data);
      } else {
        console.warn('Customer order data not available');
      }
    } catch (error) {
      console.error('Error fetching customer order details:', error);

    }
  };

  useEffect(() => {
    const storedOrderId = localStorage.getItem("params") || requestId;
    if (storedOrderId) {
      setOrderId(storedOrderId);
      fetchRequestDetails(storedOrderId);
      fetchCustomerOrderDetails(storedOrderId);
    } else {
      window.location.reload();
      setError('No order ID found');
    }
  }, [requestId]);

  console.log('projectData+++++++++++------------', projectData);
  console.log('jobNoteMembers+++++++++++------------', jobNoteMembers);
  console.log('requestDetails+++++++++++------------', requestDetails);
  console.log('orderId+++++++++++------------', orderId);
  console.log('customerOrderData+++++++++++------------', customerOrderData);

  const debugProps = {
    products: customerOrderData?.cust_product || projectData?.cust_product || [],
    requestDetails: requestDetails || projectData || {},
    requestId: orderId,
    acceptedClients: jobNoteMembers || [],
    fromDesign: requestDetails?.from_design || projectData?.from_design || false,
    isDesignOrder: requestDetails?.is_design_order || projectData?.is_design_order || false,
    details: requestDetails || projectData || {},
    renderCards: renderCards,
    setRenderCards: setRenderCards,
    fetchRequestDetails: fetchRequestDetails,
    accessPublicMessageBoard: false
  };

  console.log('Props being passed to JobCostJobNotesMessageBoard:', debugProps);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '20px' }}>
        <Alert severity="error">{error}</Alert>
      </div>
    );
  }

  if (!orderId) {
    return (
      <div style={{ padding: '20px' }}>
        <Alert severity="warning">No order ID found. Please navigate to a job cost page first.</Alert>
      </div>
    );
  }

  return (
    <div
      style={{
        borderRadius: 12,
        padding: 12,
        width: '100%',
      }}
    >
      <Typography variant='h4' sx={{ mb: 2 }}>Job Notes</Typography>
      {/* <StickyNoteJobCost
        logs={logs}
        projectData={projectData}
        setLogs={setLogs}
        fetchJobCostLogs={fetchJobCostLogs} /> */}

      <JobCostJobNotesMessageBoard
        products={debugProps.products}
        requestDetails={debugProps.requestDetails}
        requestId={debugProps.requestId}
        acceptedClients={debugProps.acceptedClients}
        fromDesign={debugProps.fromDesign}
        isDesignOrder={debugProps.isDesignOrder}
        details={debugProps.details}
        renderCards={debugProps.renderCards}
        setRenderCards={debugProps.setRenderCards}
        fetchRequestDetails={debugProps.fetchRequestDetails}
        accessPublicMessageBoard={debugProps.accessPublicMessageBoard}
      />
    </div>
  );
}
